import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import client from '../../api/client';
import { useAuth } from '../../contexts/AuthContext';
import TrainingHoursList from '../../components/TrainingHoursList';
import UserStats from '../../components/UserStats';
import ChangeRequestInbox from '../../components/ChangeRequestInbox';
import LogbookQuickActions from '../../components/LogbookQuickActions';

function LogbuchPage() {
  const { user } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);
  const [entries, setEntries] = useState([]);
  const [stats, setStats] = useState(null);
  const [complianceLights, setComplianceLights] = useState([]);
  const [requirements, setRequirements] = useState({ total: 72, trainer: 54 });
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const showEquipmentInspectorHours = Array.isArray(user?.roles) && user.roles.includes('geräteprüfer');

  useEffect(() => {
    client.get(`/api/training/my-hours?year=${selectedYear}`)
      .then((res) => {
        setEntries(res.data.hours || []);
        setComplianceLights(res.data.complianceLights || []);
        setStats({
          total_hours: res.data.stats?.total_hours || 0,
          trainer_hours: res.data.stats?.trainer_hours || 0,
          equipment_inspector_hours: res.data.stats?.equipment_inspector_hours || 0,
        });
        setRequirements(res.data.requirements || { total: 72, trainer: 54 });
      })
      .catch(() => {
        setEntries([]);
        setComplianceLights([]);
        setStats(null);
        setRequirements({ total: 72, trainer: 54 });
      });
  }, [refreshKey, selectedYear]);

  return (
    <Box sx={{ px: { xs: 1.5, sm: 2, md: 5 }, py: { xs: 2, md: 2.5 } }}>
      <Stack spacing={2.5}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.75, fontSize: { xs: '1.65rem', sm: '2rem' } }}>
            Logbuch
          </Typography>
        </Box>

        <Card sx={{ borderRadius: 3, border: 1, borderColor: 'divider' }}>
          <CardContent>
            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={12} lg={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="year-select-label">Jahr</InputLabel>
                  <Select
                    labelId="year-select-label"
                    label="Jahr"
                    value={selectedYear}
                    onChange={(event) => setSelectedYear(Number(event.target.value))}
                  >
                    {Array.from({ length: 6 }, (_, index) => currentYear - index).map((year) => (
                      <MenuItem key={year} value={year}>{year}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={9}>
                <UserStats
                  stats={stats}
                  requirements={requirements}
                  year={selectedYear}
                  inline
                  showEquipmentInspectorHours={showEquipmentInspectorHours}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ mb: 1.5 }} />
                <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-end' } }}>
                  <LogbookQuickActions user={user} />
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <ChangeRequestInbox onResolved={() => setRefreshKey((value) => value + 1)} />

        <TrainingHoursList
          entries={entries}
          user={user}
          complianceLights={complianceLights}
          refreshKey={refreshKey}
          onUpdate={() => setRefreshKey((value) => value + 1)}
        />
      </Stack>
    </Box>
  );
}

export default LogbuchPage;
